import { Dimensions } from 'react-native';

export const defaultPadding = 24;
export const screenHorizontalPadding = 24;
export const webHorizontalPadding = 48;
export const screenVerticalPadding = 12;
export const deviceHeight = Dimensions.get('window').height;
export const deviceWidth = Dimensions.get('window').width;
